import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SecurityCenterPage } from './security-center.page';

const routes: Routes = [
  {
    path: '',
    component: SecurityCenterPage
  },
  {
    path: 'change-gesture',
    loadChildren: () => import('./change-gesture/change-gesture.module').then( m => m.ChangeGesturePageModule)
  },
  {
    path: 'change-pwd',
    loadChildren: () => import('./change-pwd/change-pwd.module').then( m => m.ChangePwdPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SecurityCenterPageRoutingModule {}
